import { FormInputField, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { LocalizedSubsectionTitle } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';

export const ContactInfo = () => (
    <Stack vertical spacing="300">
        <LocalizedSubsectionTitle textKey={TextKey.ContactInfo} />

        <FormInputField
            required
            name="primaryMailAddress"
            readOnly
            label={<LocalizedText textKey={TextKey.EmailAddress} />}
        />

        <FormInputField name="telephone" label={<LocalizedText textKey={TextKey.PhoneNumberComplete} />} />
    </Stack>
);
